import React from 'react';
import notLoggedInImage from '../../../images/no-access-image.png';

const NotLoggedIn = () => {
  return (
    <div
      id="no-auth"
      style={{
        height: '85vh',
        width: '95vw',
        marginLeft: '32px',
        marginTop: '20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <img src={notLoggedInImage} />
      <p>Not Logged In</p>
    </div>
  );
};

export default NotLoggedIn;
